import { METERING_POINT_OPERATORS_LIST } from '@newnetzportal/netzportal-webapp-storybook-components';

export const COUNTER_TYPE_LIST = [
  'AHZ',
  'WSZ',
  'MAZ',
  'MME',
  'EHZ',
  'LAZ',
  'IVA',
  'NMG',
];

export const CHARGE_TYPE_LIST = ['ETZ', 'ZTZ'];
export const CURRENT_DIRECTION_LIST = [
  { value: 'oneway', translation: 'Einrichtungszäher' },
  { value: 'twoway', translation: 'Zweirichtungszähler' },
];
export const MOUNT_TYPE_LIST = [
  { value: 'DPA', translation: 'DPA' },
  { value: 'DIN', translation: 'Hutschienen' },
  { value: 'BKE', translation: 'BKE' },
];
export const MEASURING_DEVICE_TYPE_LIST = ['MMR', 'AMR'];
export const OBIS_KEY_LIST = ['1.2.8.0', '1.2.29.0'];
export const type_of_usage_options = [
  { value: 'feedin', translation: 'Einspeisung' },
  { value: 'generation', translation: 'Erzeugung' },
];

export const provider_options = METERING_POINT_OPERATORS_LIST;

export const counting_method_options = ['SLP', 'RLM'];
